import User from '../../domain/auth/User';
import { FileInfo } from '../../types/FileInfo.types';
import { resizeImgUrl, transformImgUrl } from '../../ui/uiutils/image';
import { resizeVideoUrl } from '../../ui/uiutils/video';
import { getFileData, getFileOrUrlType, getUrlPathWithoutLeadingSlash } from '../../utils/file';
import { generateNameFromFile } from '../../utils/url';
import FirebaseSource from '../source/FirebaseSource';

const THUMB_SIZE = 512;

export default class StoryRepo {
    getCurrentUser: () => Promise<User | undefined>;
    firebaseSource: FirebaseSource;

    constructor(firebaseSource: FirebaseSource, getCurrentUser: () => Promise<User | undefined>) {
        this.getCurrentUser = getCurrentUser;
        this.firebaseSource = firebaseSource;
    }

    upload = async ({ file, url, size, name, clip, onProgress }: FileInfo) => {
        if (!file) return url;
        const user = await this.getCurrentUser();
        if (!user) throw new Error('Must login to upload files');

        if (!name) name = generateNameFromFile(file.name ?? 'file');

        const path = `/story/${user?.id}/${name}`;
        const fileData = await getFileData(file, url, size === 'small', clip);
        return await this.firebaseSource.uploadFile(path, fileData, onProgress);
    };

    uploadThumbnail = async ({ file, url, name, clip }: FileInfo) => {
        const user = await this.getCurrentUser();
        if (!user) throw new Error('Must login to upload files');

        if (!name) name = generateNameFromFile(file?.name ?? 'file', 'jpg');

        const path = `/story/${user?.id}/${name}`;
        const type = getFileOrUrlType(url, file);
        const fileData =
            type === 'video'
                ? await resizeVideoUrl(url, THUMB_SIZE)
                : clip
                ? await transformImgUrl(url, clip, THUMB_SIZE)
                : await resizeImgUrl(url, THUMB_SIZE);
        return await this.firebaseSource.uploadFile(path, fileData);
    };

    transcode = async ({ url, duration, width, height }: TranscodeInfo): Promise<string> => {
        return await this.firebaseSource.call('transcode', {
            path: getUrlPathWithoutLeadingSlash(url),
            duration,
            width,
            height,
        });
    };
}

export type TranscodeInfo = {
    url: string;
    duration: number;
    width: number;
    height: number;
};
